export default __webpack_public_path__ + "static/media/big.7ad136c7.jpg";